import Header from "./Header";
import Footer from "./Footer";
// import CTASection from "./CTASection";
import "../styles/header/header.css";
import "../styles/termOfUse/term.css";
export default function PolicyPage() {
  return (
    <div className="main">
      <Header />
      <div
        className="terms-policy">
        <h1 >
          Privacy Policy
        </h1>

        <p className="p-head">This is the official Government Form website.</p>
        <h3>Data We Collect and How We Use It</h3>
        <p>

          When you simply browse this website, we don't collect data that
          identifies you personally. We use technologies, like cookies, to
          understand how people use our site so we can improve it. This
          information helps us customize your experience and may be shared with
          our trusted government partners to enhance your experience on their
          websites as well.
        </p>

        <p>
          These technologies do not capture any personal data about you.
          Instead, they focus on your browsing patterns on this site and others
          you visit after leaving.
        </p>
        <h3>Your Choices About Cookies</h3>
        <p>
          You can choose to accept or decline cookies. Most web browsers
          automatically accept cookies, but you can change your browser settings
          to decline them if you prefer. Just be aware that this might prevent
          you from using all the features of the website.
        </p>
        <h3>When You Provide Personal Data</h3>
        <p>
          When you provide us with personal information, we may share that data
          with other government agencies to serve you as efficiently as
          possible, unless a law prohibits us from doing so.
        </p>

        <p>
          We will not share your personal data with non-government entities
          unless they are authorized to perform a specific government service on
          our behalf.
        </p>

        <p>
          We may also show you data you've previously submitted to us or another
          government agency. This saves you time by not having to re-enter
          information you've already provided. If any of this data is outdated,
          please be sure to update it.
        </p>
        <h3>How We Protect Your Data</h3>
        <p>
          To protect your personal data, we secure all electronic storage and
          transmission using appropriate security technologies.
        </p>

        <p>
          If you have questions, feedback, or need more information about the
          data you've provided to us in the past, please contact us at{" "}
          <strong><a href="mailto:info@ai.gov.kh">info@ai.gov.kh</a></strong>.
        </p>
      </div>
      {/* <CTASection /> */}
      <Footer hideFooter={false} />
    </div>
  );
}
